import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import PropertyGroupBoxViewModel from '@/ViewModels/Controls/PropertyGroupBoxViewModel';
import ColorPickerViewModel from '@/ViewModels/Controls/ColorPickerViewModel';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';

export default class DesignWizardSubViewModel extends ControlViewModel {
    private PropertyGroupBoxViewModel = ComponentManager.getViewModel<typeof PropertyGroupBoxViewModel>('PropertyGroupBoxViewModel');
    private ColorPickerViewModel = ComponentManager.getViewModel<typeof ColorPickerViewModel>('ColorPickerViewModel');
    private LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');

    /**
     * Der Wert des Controls
     */
    public value: KnockoutObservable<any>;

    public control: string;
    public ergName: string;
    public key: any;
    public defaultValue: any;
    public options: any;

    /**
     * Der angezeigte Fehlertext
     */
    public error: KnockoutObservable<string>;

    /**
     * Das Fehler-Label, falls das Design keine Änderungen zulässt
     */
    public label: LabelViewModel;

    /**
     * Ein Observable zum Aktualisieren der Factories
     */
    public refresh: KnockoutObservable<any>;

    /**
     * Das ViewModel für das DesignWizardItem
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.value = this.observableOrDefault(params.value, params.defaultValue);

        this.defineSubscription(this.value, () => {
            this.refresh(new Date());
        });

        this.control = this.paramOrDefault(params.control, '');
        this.ergName = this.paramOrDefault(params.ergName, '');
        this.key = this.paramOrDefault(params.key, null);
        this.defaultValue = this.paramOrDefault(params.defaultValue, null);
        this.options = this.paramOrDefault(params.options, null);
        this.error = this.observableOrDefault(params.error, null);

        this.label = new this.LabelViewModel({
            caption: this.error,
            isVisible: this.defineComputed(() => {
                return this.error() != null;
            })
        });

        this.refresh = this.observableOrDefault(params.refresh, null);
    }
}

ComponentManager.setViewModel('DesignWizardSubViewModel', DesignWizardSubViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');